import { GET_USER_INFO_FROM_MILES, GET_USER_INFO_FROM_MILES_SUCCESS, GET_USER_MILES, GET_USER_MILES_SUCCESS, GET_MONTHLY_RANKING_SUCCESS, GET_PAST_MONTHLY_RANKING_SUCCESS, BALANCE_INQUIRY_API_SUCCESS, UNLINK_CARD_SUCCESS, LINK_KFC_CARD_SUCCESS, ERROR_MSG, IS_LOADING, GET_USER_MILES_CURRENT_HISTORY_SUCCESS, GET_USER_MILES_PAST_HISTORY_SUCCESS, GET_RANKING_View_SUCCESS, GET_OVERALL_RANKING_SUCCESS, GET_USER_OVERALL_RANKING_SUCCESS, GET_LAST_MONTH_RANKING_View_SUCCESS, STORE_RETURNED_ACCOUNT_ID, LINK_CARD_STATUS, CLEAR_KFC_LINKING_DATA, } from '../../constants';
const initialState = {
    userMiles: {},
    pickedData: {},
    isLoading: false,
    errorMsg: false,
};
const loyaltyMileageReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_INFO_FROM_MILES:
            return {
                ...state,
                isLoading: true,
            };
        case GET_USER_INFO_FROM_MILES_SUCCESS:
            const { userMiles } = action.payload;
            return {
                ...state,
                isLoading: false,
                userMiles,
            };
        case GET_USER_MILES:
            return {
                ...state,
                isLoading: true,
            };
        case GET_USER_MILES_SUCCESS:
            const { pickedData } = action.payload;
            return {
                ...state,
                isLoading: false,
                pickedData,
            };
        case GET_MONTHLY_RANKING_SUCCESS:
            const { monthlyRankingData } = action.payload;
            return {
                ...state,
                isLoading: false,
                monthlyRankingData,
            };
        case GET_PAST_MONTHLY_RANKING_SUCCESS:
            const { pastMonthlyRankingData } = action.payload;
            return {
                ...state,
                isLoading: false,
                pastMonthlyRankingData,
            };
        case GET_RANKING_View_SUCCESS:
            const { rankingViewData } = action.payload;
            return {
                ...state,
                isLoading: false,
                rankingViewData,
            };
        case GET_OVERALL_RANKING_SUCCESS:
            const { overAllRankingData } = action.payload;
            return {
                ...state,
                isLoading: false,
                overAllRankingData,
            };
        case GET_USER_OVERALL_RANKING_SUCCESS:
            const { userOverAllRankingData } = action.payload;
            return {
                ...state,
                isLoading: false,
                userOverAllRankingData,
            };
        case GET_LAST_MONTH_RANKING_View_SUCCESS:
            const { lastMonthRankingViewData } = action.payload;
            return {
                ...state,
                isLoading: false,
                lastMonthRankingViewData,
            };
        case GET_USER_MILES_CURRENT_HISTORY_SUCCESS:
            const { currentMilesHisory } = action.payload;
            return {
                ...state,
                isLoading: false,
                currentMilesHisory,
            };
        case GET_USER_MILES_PAST_HISTORY_SUCCESS:
            const { pastMilesHisory } = action.payload;
            return {
                ...state,
                isLoading: false,
                pastMilesHisory,
            };
        case BALANCE_INQUIRY_API_SUCCESS:
            const { kfcLinkingData } = action.payload;
            return {
                ...state,
                isLoading: false,
                kfcLinkingData,
            };
        case UNLINK_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case LINK_KFC_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: action.success,
            };
        case ERROR_MSG:
            return {
                ...state,
                isLoading: false,
                errorMsg: action.errorMsg,
            };
        case IS_LOADING:
            return {
                ...state,
                loading: action.isLoading,
            };
        case STORE_RETURNED_ACCOUNT_ID:
            return {
                ...state,
                pontaAccountID: action.pontaAccountID,
            };
        case LINK_CARD_STATUS:
            return {
                ...state,
                linkingStatus: action.payload,
            };
        case CLEAR_KFC_LINKING_DATA:
            const { clearLinkingData } = action.payload;
            return {
                ...state,
                kfcLinkingData: clearLinkingData,
            };
        default:
            return state;
    }
};
export default loyaltyMileageReducer;
